export default "__VITE_ASSET__Cptxf7EM__"